import type { Route } from '~/core/router'

import * as root from '~/routes/home/root'
import { InfoPopup } from '~/widgets/Popups'

export const route: Route = {
  children: [
    {
      path: '',
      component: [root.Title, root.HomePage, InfoPopup],
      init: root.model.init,
      left: root.model.left,
    },
  ],
}
